import { PRODUCT_BASE_PATHS } from '@cast/console-constants';

import { KarpenterSettingsTabs } from './_constants';

type KarpenterSettingsLinkArgs = {
  clusterId: string;
  tab?: `${KarpenterSettingsTabs}`;
};

export const makeKarpenterSettingsLink = ({
  clusterId,
  tab = 'node-pools',
}: KarpenterSettingsLinkArgs) => {
  return `${PRODUCT_BASE_PATHS.automation}/external-clusters/${clusterId}/karpenter/settings/${tab}`;
};

export const makeKentGetStartedLink = ({
  clusterId,
}: {
  clusterId: string;
}) => {
  return `${PRODUCT_BASE_PATHS.automation}/external-clusters/${clusterId}/karpenter/get-started`;
};

export const makeKentSettingsLink = ({ clusterId }: { clusterId: string }) => {
  return `${PRODUCT_BASE_PATHS.automation}/external-clusters/${clusterId}/settings`;
};

type ConsolidationSettingsLinkArgs = {
  clusterId: string;
};

export const makeConsolidationSettingsLink = ({
  clusterId,
}: ConsolidationSettingsLinkArgs) => {
  return `${makeKentSettingsLink({ clusterId })}/consolidation`;
};
